module.exports = __webpack_public_path__ + "static/media/back.afc526ce.svg";